import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Admin from "@/components/admin/Admin";
import { SmoothScroll } from "@/components/landing/motion";
import { Hero } from "@/components/landing/Hero";
import { Chapter } from "@/components/landing/Chapter";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Timeline } from "@/components/landing/Timeline";
import { WhyThursdays } from "@/components/landing/WhyThursdays";
import { WhatWorkingOn } from "@/components/landing/WhatWorkingOn";
import { Included } from "@/components/landing/Included";
import { FeeLocation } from "@/components/landing/FeeLocation";
import { RsvpForm } from "@/components/landing/RsvpForm";
import { Footer } from "@/components/landing/Footer";

function Landing() {
  return (
    <SmoothScroll>
      <div className="App bg-oat">
        <Hero />

        <Chapter
          id="why-now"
          testId="why-now"
          number="01"
          kicker="why now"
          heading="become yourself, together"
          tone="mushroom-light"
        >
          <p>
            we're moving into a season astrologically that's asking two things of us at once. to
            become more fully ourselves, and to do it together. to get honest and creative about what
            we're here to make, and to stay woven into a community while we make it. that's what this
            gathering is. you come create what you're meant to, and you're held by a room of women
            doing the same.
          </p>
        </Chapter>

        <Chapter
          id="what-it-is"
          testId="what-it-is"
          number="02"
          kicker="what it is"
          heading="creativity in the same room"
          tone="oat"
        >
          <p>
            an in-person gathering for women who are building, creating, or moving something forward.
            you bring one real project. we open with coffee and connection, then give it a focused
            hour of work. you work on your own thing, next to women working on theirs. creativity,
            accountability, and community, in the same room.
          </p>
        </Chapter>

        <EditorialMarquee />

        <Timeline />

        <WhyThursdays />

        <WhatWorkingOn />

        <Included />

        <FeeLocation />

        <RsvpForm />

        <Footer />
      </div>
    </SmoothScroll>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
